import React from "react";
import styles from "../stylesER.module.scss";

export const VariosModal = ({
  isOpen,
  monthIndex,
  selectedYear,
  mesesCompletos,
  variosDetalleTemp,
  nuevoVariosConcepto,
  setNuevoVariosConcepto,
  nuevoVariosMonto,
  setNuevoVariosMonto,
  agregarItemVarios,
  eliminarItemVarios,
  calcularTotalVarios,
  guardarVariosDetalle,
  cerrarModalVarios,
  formatCurrency,
  moneda,
  pais,
}) => {
  if (!isOpen || monthIndex === null) return null;

  return (
    <div className={styles.modalOverlay} onClick={cerrarModalVarios}>
      <div
        className={styles.modalContent}
        style={{ maxWidth: "650px", width: "95%" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3>
          Varios - {mesesCompletos[monthIndex]} {selectedYear}
        </h3>

        {variosDetalleTemp.length > 0 ? (
          <table className={styles.modalTable} style={{ marginBottom: "20px" }}>
            <thead>
              <tr>
                <th style={{ width: "55%", textAlign: "left" }}>Concepto</th>
                <th style={{ width: "30%", textAlign: "right" }}>Monto</th>
                <th style={{ width: "15%", textAlign: "center" }}>Acción</th>
              </tr>
            </thead>
            <tbody>
              {variosDetalleTemp.map((item) => (
                <tr key={item.id}>
                  <td style={{ textAlign: "left", fontWeight: "500" }}>{item.concepto}</td>
                  <td style={{ textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
                    {formatCurrency(item.monto)}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <button
                      onClick={() => eliminarItemVarios(item.id, item.concepto)}
                      style={{
                        background: "#dc3545",
                        color: "white",
                        border: "none",
                        padding: "6px 12px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                      }}
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div
            style={{
              padding: "24px",
              textAlign: "center",
              color: "#666",
              backgroundColor: "#f9f9f9",
              borderRadius: "8px",
              marginBottom: "20px",
              fontStyle: "italic",
            }}
          >
            No hay gastos registrados. Agrega el primero.
          </div>
        )}

        <div
          style={{
            background: "#f8f9fa",
            padding: "16px",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 150px 100px",
              gap: "12px",
              alignItems: "end",
            }}
          >
            <div>
              <label style={{ display: "block", marginBottom: "6px", fontWeight: "600", fontSize: "0.85rem" }}>
                Concepto *
              </label>
              <input
                type="text"
                value={nuevoVariosConcepto}
                onChange={(e) => setNuevoVariosConcepto(e.target.value)}
                placeholder="Ej: Limpieza, Útiles..."
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  fontSize: "0.9rem",
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    agregarItemVarios();
                  }
                }}
              />
            </div>

            <div>
              <label style={{ display: "block", marginBottom: "6px", fontWeight: "600", fontSize: "0.85rem" }}>
                Monto
              </label>
              <div style={{ position: "relative" }}>
                <span
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#666",
                    fontWeight: "600",
                    fontSize: "0.85rem",
                  }}
                >
                  {moneda(pais).trim()}
                </span>
                <input
                  type="number"
                  value={nuevoVariosMonto}
                  onChange={(e) => setNuevoVariosMonto(e.target.value)}
                  placeholder="0"
                  min="0"
                  style={{
                    width: "100%",
                    padding: "10px 12px 10px 35px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem",
                    textAlign: "right",
                  }}
                  onWheel={(e) => e.preventDefault()}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      agregarItemVarios();
                    }
                  }}
                />
              </div>
            </div>

            <button
              onClick={agregarItemVarios}
              style={{
                padding: "10px 16px",
                background: "#1976d2",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "600",
                fontSize: "0.9rem",
                height: "42px",
              }}
            >
              + Agregar
            </button>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 20px",
            backgroundColor: "#e8f5e9",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          <span style={{ fontSize: "1.1rem", fontWeight: "600", color: "#2c3e50" }}>TOTAL</span>
          <span style={{ fontSize: "1.3rem", fontWeight: "700", color: "#1b5e20" }}>
            {formatCurrency(calcularTotalVarios())}
          </span>
        </div>

        <div className={styles.modalActions}>
          <button className={styles.btnSave} onClick={guardarVariosDetalle}>
            Guardar
          </button>
          <button className={styles.btnCancel} onClick={cerrarModalVarios}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};
